import { createHttpEndpoint } from '../../utils'

import type {
  GetPaymentMethods,
  GetPaymentMethodsKonbiniSettings,
} from './payment-methods.types'

/**
 * Retrieve payment methods as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Payment-methods/operation/get-bm-merchants-payment-methods}
 */
export const getPaymentMethods = createHttpEndpoint<GetPaymentMethods>({
  method: 'GET',
  operationId: 'getMerchantPaymentData',
  path: '/bm/merchants/payment-methods',
})

/**
 * Retrieve Konbini information as an authenticated japanese seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Payment-methods/operation/get-bm-merchants-payment-methods-konbini}
 */
export const getPaymentMethodsKonbiniSettings =
  createHttpEndpoint<GetPaymentMethodsKonbiniSettings>({
    method: 'GET',
    operationId: 'getMerchantKonbiniSettings',
    path: '/bm/merchants/payment-methods/konbini',
    transformResponseToCamelCase: true,
  })

/**
 * Upsert Konbini information as an authenticated japanese seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Payment-methods/operation/put-bm-merchants-payment-methods-konbini}
 */
export const putPaymentMethodsKonbiniSettings = createHttpEndpoint({
  method: 'PUT',
  operationId: 'updateMerchantKonbiniSettings',
  path: '/bm/merchants/payment-methods/konbini',
  transformResponseToCamelCase: true,
})
